import { query, collection, onSnapshot, orderBy, where, limit, startAt, startAfter, getDocs } from "firebase/firestore";
import { useEffect, useState } from "react";
import FlatList from 'flatlist-react';
import { db } from "../../../../../globals/firebase";
import JobDetail1Page from "../../components/jobs/job-detail1";
import { NavLink, useNavigate } from "react-router-dom";
import { publicUser } from "../../../../../globals/route-names";
import { BsJournalRichtext } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import { setDefaultOptions } from "date-fns";
import { pt } from 'date-fns/locale'


function SectionJobsListRootPrompts() {

    const navigate = useNavigate();

    const [listadeprompts, setlistadeprompts] = useState([])
    const [hasMoreItems, sethasMoreItems] = useState(false)
    const [Offset, setOffset] = useState(null)
    const [user, setuser] = useState(null)

    const { t, i18n } = useTranslation()

    useEffect(() => {
        setuser(JSON.parse(localStorage.getItem("user")))
        setfirst()


        if (i18n.language == "pt-BR" || i18n.language == "pt") {
            setDefaultOptions({ locale: pt })
        }


    }, [])



    const setfirst = async () => {
        const getfirst = query(collection(db, "wpm_prompts"), where("public", "==", true), orderBy("datainsert", "desc"), limit(5))
        const documentSnapshots = await getDocs(getfirst);
        const first = documentSnapshots.docs[0];
        setOffset(first)
        loadchanges(first, "first")

    }

    const showBlank = () => {
        if (listadeprompts.length === 0) {
            return <div>Loading list...</div>
        }

        return <div>No items for this list</div>
    }

    const loadchanges = async (docfrom, start) => {

        let q = null
        if (start === "first") {
            q = query(collection(db, "wpm_prompts"), where("public", "==", true), orderBy("datainsert", "desc"), startAt(docfrom), limit(30));
        }


        if (start === "last") {
            q = query(collection(db, "wpm_prompts"), where("public", "==", true), orderBy("datainsert", "desc"), startAfter(docfrom), limit(30));
        }

        onSnapshot(q, async (querySnapshot) => {
            const newTodos = [...listadeprompts];
            querySnapshot.forEach((doc) => {
                const docinsert = {
                    id: doc.id,
                    imageurl: doc.data().imageurl,
                    prompttitle: doc.data().prompttitle,
                    prompt: doc.data().prompttext,
                    public: doc.data().public,
                    dateinsert: doc.data().datainsert,
                    userid: doc.data().userid,
                    username: doc.data().username || ""
                }
                newTodos.push(docinsert);
                setOffset(doc)
            });

            setlistadeprompts(newTodos);
            sethasMoreItems(listadeprompts.length < querySnapshot.docs.length)


        })

    }

    const gotopromtps = () => {
        navigate(publicUser.jobs.LIST)
    }

    return (
        <>
            <div style={{ display: "flex", paddingLeft: "20px", flexDirection: "column", width: "100%" }}>
                <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                    <div style={{ paddingRight: "20px", fontWeight: "bold", fontSize: "14px" }}>
                        {listadeprompts.length} {t('promptsroot.publicprompts')}
                    </div>

                    {user == null || user == undefined ?

                        <div>
                            <a className="site-button" data-bs-toggle="modal" href="#sign_up_popup2" role="button">
                                <i className="feather-log-in" />
                                {t('promptsroot.signintorun')}
                            </a>
                        </div>

                        :

                        <div>

                            <NavLink to={publicUser.jobs.LIST} className="twm-job-title">
                                <span className="site-button">
                                    <BsJournalRichtext color="white" size="15" />
                                    {t('promptsroot.createprompt')}

                                </span>
                            </NavLink>

                        </div>

                    }
                </div>

                <div style={{ width: "100%" }}>
                    <FlatList
                        list={listadeprompts}
                        displayGrid
                        minColumnWidth="300px"
                        gridGap="15px"
                        srollToTop
                        renderWhenEmpty={showBlank}
                        //loadMoreItems={loadchanges(Offset, "last")}
                        renderItem={(doc) =>
                            <div key={doc.id} className="masonry-wrap row d-flex">
                                <JobDetail1Page doc={doc}></JobDetail1Page>
                            </div>

                        }
                    />

                </div>
                {hasMoreItems == false ?
                    <div style={{ padding: "20px", alignSelf: "center", width: "200px" }}>
                        <button className="site-button" onClick={(e) => { e.preventDefault(); loadchanges(Offset, "last") }}>Load More</button>
                    </div>

                    : ""}
            </div>
        </>
    )
}

export default SectionJobsListRootPrompts;